import { render } from "./About.vue?vue&type=template&id=57842f44&lang=pug"
const script = {}

import exportComponent from "/builds/kaplife/telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__